export default __webpack_public_path__ + "static/media/heroimage3.3110f858.png";